export default __webpack_public_path__ + "static/media/SSS.d5cf3dd3.png";